import {
  type AllSelectionListsWithSkillTaxonomyKey,
  FilterId,
} from '../types/filters';

export const RICS_TAXONOMY_TREE_LEVELS = [1, 3, 4];
export const RICS_COMPANY_SELECTION_LIST_IDS: AllSelectionListsWithSkillTaxonomyKey[] =
  ['rics_k10', 'rics_k400', 'company'];
export const RICS_INDUSTRY_SELECTION_LIST_IDS: AllSelectionListsWithSkillTaxonomyKey[] =
  ['rics_k10', 'rics_k400'];

export const isRicsCompanyFilter = (filterId: FilterId) =>
  filterId === FilterId.COMPANY ||
  filterId === FilterId.COMPETITORS ||
  filterId === FilterId.FOUNDER_COMPANY;

export const isRicsReferenceFilter = (filterId: FilterId) =>
  isRicsCompanyFilter(filterId) || filterId === FilterId.INDUSTRY;

export const pruneTreeToDepth = <T extends { children?: T[] }>(
  nodes: readonly T[],
  maxDepth: number,
  depth = 0
): T[] =>
  nodes.map((node) => {
    if (depth >= maxDepth || !node.children?.length) {
      return { ...node, children: undefined };
    }

    return {
      ...node,
      children: pruneTreeToDepth(node.children, maxDepth, depth + 1),
    };
  });

export const stripTreeNodeTooltipData = <
  T extends {
    children?: T[];
    info?: unknown;
    suggestedTitles?: unknown;
    taxonomyTitles?: unknown;
  },
>(
  nodes: T[]
): T[] => {
  const stack = [...nodes];
  while (stack.length > 0) {
    const node = stack.pop();
    if (node === undefined) {
      break;
    }
    node.info = undefined;
    node.suggestedTitles = undefined;
    node.taxonomyTitles = undefined;
    if (node.children) {
      for (let i = 0; i < node.children.length; i++) {
        const child = node.children[i];
        if (child !== undefined) {
          stack.push(child);
        }
      }
    }
  }
  return nodes;
};
